{
  "cycle.entite.organisation_export_siem": "Destination SIEM de l’organisation",
  "cycle.entite.organisation_export_siem_envois": "Envois vers le SIEM de l’organisation",
  "journalAudit.action.audit.package_downloaded": "Paquet d’audit de l’organisation téléchargé",
  "journalAudit.action.org.siem_configured": "Destination SIEM de l’organisation enregistrée",
  "v8e.journal.acteur": "Acteur",
  "v8e.journal.acteurInconnu": "acteur inconnu",
  "v8e.journal.action": "Action",
  "v8e.journal.arretsDUrgence": "Historique des arrêts d’urgence",
  "v8e.journal.au": "Au (exclu)",
  "v8e.journal.aucunResultat": "Aucune entrée pour ces filtres.",
  "v8e.journal.automatiques": "Inclure les événements automatiques",
  "v8e.journal.categorie": "Catégorie",
  "v8e.journal.categorie.facturation": "Facturation (si vous la voyez)",
  "v8e.journal.categorie.ia": "IA",
  "v8e.journal.categorie.membres": "Membres et invitations",
  "v8e.journal.categorie.profils": "Profils et droits",
  "v8e.journal.categorie.programmes": "Programmes",
  "v8e.journal.categorie.projets": "Projets",
  "v8e.journal.categorie.securite": "Sécurité et accès",
  "v8e.journal.categorie.technologies": "Technologies",
  "v8e.journal.categorie.toutes": "Toutes",
  "v8e.journal.chaineRompue": "chaîne rompue",
  "v8e.journal.chaineVerifiee": "chaîne vérifiée",
  "v8e.journal.code.CONFLIT_CONCURRENT": "La destination a été modifiée entre-temps : rechargez la page puis recommencez.",
  "v8e.journal.code.EGRESS_HOST_NOT_ALLOWED": "Cet hôte n’est pas dans la liste des sorties autorisées par l’opérateur.",
  "v8e.journal.code.EGRESS_METADATA_BLOCKED": "Cette adresse vise des métadonnées du nuage : elle est refusée.",
  "v8e.journal.code.PROVIDER_SECRET_UNAVAILABLE": "Le secret référencé est introuvable dans le magasin de secrets.",
  "v8e.journal.code.V8E_PAQUET_TROP_VOLUMINEUX": "Trop de lignes pour un paquet (plus de 200 000) : réduisez la période.",
  "v8e.journal.code.V8E_SIEM_ADRESSE_INTERNE": "Cette adresse mène à un réseau interne : elle est refusée.",
  "v8e.journal.code.V8E_SIEM_FACTURATION_NON_TENUE": "Inclure la facturation exige de pouvoir la voir.",
  "v8e.journal.code.V8E_SIEM_HTTPS_EXIGE": "L’adresse du SIEM doit commencer par https://.",
  "v8e.journal.code.V8E_SIEM_REFERENCE_HORS_ORGANISATION": "La référence du secret doit être de la forme org-<organisation>-siem-<nom>, nom en minuscules et chiffres.",
  "v8e.journal.conservationSansProjet": "La conservation et la purge se règlent encore par projet : ouvrez un projet dans le sélecteur de contexte.",
  "v8e.journal.csvPret": "Le CSV des filtres choisis est téléchargé.",
  "v8e.journal.datesInversees": "La date de début doit précéder la date de fin.",
  "v8e.journal.deplier": "Voir les détails techniques",
  "v8e.journal.detail": "Détail de l’entrée",
  "v8e.journal.du": "Du",
  "v8e.journal.envoi.en_echec": "{{quand}} — envoi en échec, code {{code}}.",
  "v8e.journal.envoi.facturationExclue": "Événements de facturation exclus.",
  "v8e.journal.envoi.reussi": "{{quand}} — envoi réussi, {{lignes}} ligne(s), code {{code}}.",
  "v8e.journal.envois": "Derniers envois",
  "v8e.journal.envoisVide": "Aucun envoi pour l’instant.",
  "v8e.journal.exportPret": "Export prêt — empreinte SHA-256 {{empreinte}} ({{chaine}}).",
  "v8e.journal.exporterCsv": "Exporter en CSV",
  "v8e.journal.exports": "Exports pour audit",
  "v8e.journal.filtres": "Filtres",
  "v8e.journal.genererExport": "Générer l’export pour audit",
  "v8e.journal.objet": "Objet",
  "v8e.journal.onglet.conservation": "Conservation et purge",
  "v8e.journal.onglet.journal": "Journal",
  "v8e.journal.onglets": "Sections du journal",
  "v8e.journal.pagination": "{{debut}}–{{fin}} sur {{total}}",
  "v8e.journal.paquetPeriode": "Choisissez une période (366 jours au plus) pour télécharger le paquet.",
  "v8e.journal.paquetPret": "Paquet téléchargé — empreinte du manifeste {{empreinte}}, consignée dans le journal.",
  "v8e.journal.phrase": "{{quand}} — {{acteur}} : {{action}} {{objet}}",
  "v8e.journal.portee": "Portée",
  "v8e.journal.portee.identifiant.programme": "Identifiant du programme",
  "v8e.journal.portee.identifiant.projet": "Identifiant du projet",
  "v8e.journal.portee.organisation": "Toute l’organisation",
  "v8e.journal.portee.programme": "Un programme",
  "v8e.journal.portee.projet": "Un projet",
  "v8e.journal.precedents": "Plus récents",
  "v8e.journal.pseudonymiser": "Pseudonymiser les personnes",
  "v8e.journal.replier": "Masquer les détails techniques",
  "v8e.journal.siem": "Diffusion vers votre SIEM",
  "v8e.journal.siem.actif": "Diffusion active",
  "v8e.journal.siem.adresse": "Adresse du collecteur (https)",
  "v8e.journal.siem.enregistree": "Destination enregistrée.",
  "v8e.journal.siem.enregistrer": "Enregistrer la destination",
  "v8e.journal.siem.facturation": "Inclure les événements de facturation",
  "v8e.journal.siem.facturationNonTenue": "Vous ne voyez pas la facturation : elle ne peut pas être incluse.",
  "v8e.journal.siem.format": "Format",
  "v8e.journal.siem.nonVisible": "La diffusion vers le SIEM est réservée à qui exporte le journal.",
  "v8e.journal.siem.reference": "Référence du jeton dans le magasin de secrets",
  "v8e.journal.siem.referenceAide": "Jamais la valeur : seulement son nom (minuscules et chiffres, 40 au plus).",
  "v8e.journal.siem.relais": "Les envois partent par le relais de la plateforme ; tant qu’il n’est pas en service, aucun envoi n’a lieu.",
  "v8e.journal.signatureK15": "Empreinte SHA-256 seulement : la signature de l’organisation n’est pas encore disponible.",
  "v8e.journal.source": "Source",
  "v8e.journal.suivants": "Plus anciens",
  "v8e.journal.telechargerPaquet": "Télécharger le paquet d’audit"
}
